import { render, staticRenderFns } from "./ObjectAccept.vue?vue&type=template&id=224b9a4a&"
import script from "./ObjectAccept.vue?vue&type=script&lang=ts&"
export * from "./ObjectAccept.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports